'use client';

import { trackSignIn } from '@/lib/analytics';
import { useEffect, useRef } from 'react';

export function SignInTracker() {
  const processedRef = useRef(false);

  useEffect(() => {
    // Check for our sign_in tracking cookie
    const checkSignInCookie = () => {
      if (processedRef.current) {
        return;
      }

      const match = document.cookie.match(/(^| )zappingai_sign_in=([^;]+)/);

      if (match && match[2] === 'true') {
        // Get the user email cookie for Klaviyo
        const emailMatch = document.cookie.match(/(^| )zappingai_user_email=([^;]+)/);
        let email: string | null = null;
        if (emailMatch?.[2]) {
          try {
            email = decodeURIComponent(emailMatch[2]);
          } catch {
            email = null;
          }
        }

        // Check if gtag is available - if not, wait for it
        if (typeof window.gtag !== 'function') {
          return false; // Return false to indicate we should retry
        }

        trackSignIn('social_signin', { email });
        processedRef.current = true;

        // Clear the cookie so it doesn't fire again
        document.cookie = 'zappingai_sign_in=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        document.cookie = 'zappingai_user_email=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';

        return true; // Return true to indicate success
      }
      return false;
    };

    // Run immediately and keep checking until success or timeout
    const intervals = [100, 300, 500, 1000, 2000, 3000, 5000];
    const timeouts = intervals.map((delay) =>
      setTimeout(() => {
        if (!processedRef.current) {
          checkSignInCookie();
        }
      }, delay)
    );

    return () => {
      timeouts.forEach(clearTimeout);
    };
  }, []); // Empty dependency array - run once on mount

  return null;
}
